export enum IpcChannels {
  GetTaskCreationDataRequest = 'getTaskCreationDataRequest',
  GetTaskCreationDataResponse = 'getTaskCreationDataResponse',
}
